import PageIntro from '../../components/PageIntro/PageIntro';
import MatchedTalentsTable from '../../components/Table/MatchedTalentsTable';

const MatchedTalents = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro title={'Matched Talents'} />
      <MatchedTalentsTable />
    </div>
  );
};

export default MatchedTalents;
